import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import contactService from '../../../Services/contactService';
import ClientPOCExportSearchParams from './ClientPOCExportSearchParams';

export default class ClientPOCExportWindowDescription {
  static headerForCreatePanel = 'Client POC List Export';
  static labelForSubmitButton = 'Export';
  static itemType = ClientPOCExportSearchParams;
  static clickOnSubmitFunction = contactService.ExportClientPOCList;
  static waitForResponseOnSubmit = false;
  static messageOnSuccess =
    'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.';
  static messageOnError = '{error}';

  static fieldsInEditPanel = [
    {
      fieldName: 'OfficeId',
      label: 'Office',
      className: 'col-12',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
      validityChecker: ValidityHelper.AlwaysFlawless,
    },
    {
      fieldName: 'ClientIsActive',
      label: 'Client Active',
      className: 'col-12',
      type: InputTypesEnum.EmptyYesNoSelect,
      validityChecker: ValidityHelper.AlwaysFlawless,
    },
  ];
}
